import { createAction } from "redux-actions";
import humps from "humps";
import moment from "moment";
import { apiGet } from "util/api";
import { handleSoloAnnotation, handleSoloRemoveFile } from "util/solo";
import * as types from "./constants";
import annotatePropsSelector from "./selectors";
// eslint-disable-next-line import/no-cycle
import { soloUploadFilesInvalidate } from "../upload/actions";
// eslint-disable-next-line import/no-cycle
import { soloConfirmFilesInvalidate } from "../confirm/actions";

/* eslint-disable max-len */
export const soloOpenAnnotationModal = createAction(
  types.SOLO_ANNOTATE_MODAL_OPEN
);
export const soloCloseAnnotationModal = createAction(
  types.SOLO_ANNOTATE_MODAL_CLOSE
);
export const soloSetAnnotationModalCast = createAction(
  types.SOLO_ANNOTATE_MODAL_SET_CAST
);
export const soloSetAnnotationModalForms = createAction(
  types.SOLO_ANNOTATE_MODAL_SET_FORMS
);
export const soloSetAnnotationModalSelected = createAction(
  types.SOLO_ANNOTATE_MODAL_SET_SELECTED
);
export const soloOpenChartModal = createAction(types.SOLO_CHART_MODAL_OPEN);
export const soloCloseChartModal = createAction(types.SOLO_CHART_MODAL_CLOSE);
export const soloSetChartModalCast = createAction(
  types.SOLO_CHART_MODAL_SET_CAST
);
export const soloUpdateChartModalCast = createAction(
  types.SOLO_CHART_MODAL_UPDATE_CAST
);
export const soloOpenAnnotationSnackbar = createAction(
  types.SOLO_ANNOTATE_SNACKBAR_OPEN
);
export const soloCloseAnnotationSnackbar = createAction(
  types.SOLO_ANNOTATE_SNACKBAR_CLOSE
);
export const soloRemoveFileRequest = createAction(
  types.SOLO_REMOVE_FILE_REQUEST
);
export const soloRemoveFileSuccess = createAction(
  types.SOLO_REMOVE_FILE_SUCCESS
);
export const soloRemoveFileError = createAction(
  types.SOLO_REMOVE_FILE_ERROR,
  x => x,
  (x, m) => m
);
export const soloAnnotateFilesRequest = createAction(
  types.SOLO_ANNOTATE_FILES_REQUEST
);
export const soloAnnotateFilesSuccess = createAction(
  types.SOLO_ANNOTATE_FILES_SUCCESS
);
export const soloAnnotateFilesError = createAction(
  types.SOLO_ANNOTATE_FILES_ERROR,
  x => x,
  (x, m) => m
);
export const soloFilesToAnnotateInvalidate = createAction(
  types.SOLO_ANNOTATE_FILES_INVALIDATE
);
export const soloFilesToAnnotateFetchRequest = createAction(
  types.SOLO_ANNOTATE_FILES_FETCH_REQUEST
);
export const soloFilesToAnnotateFetchSuccess = createAction(
  types.SOLO_ANNOTATE_FILES_FETCH_SUCCESS
);
export const soloFilesToAnnotateFetchError = createAction(
  types.SOLO_ANNOTATE_FILES_FETCH_ERROR
);
export const soloUpdateFile = createAction(types.SOLO_ANNOTATE_UPDATE_FILE);
export const soloCastsToAnnotateFetchRequest = createAction(
  types.SOLO_ANNOTATE_CASTS_FETCH_REQUEST
);
export const soloCastsToAnnotateFetchSuccess = createAction(
  types.SOLO_ANNOTATE_CASTS_FETCH_SUCCESS
);
export const soloCastsToAnnotateFetchError = createAction(
  types.SOLO_ANNOTATE_CASTS_FETCH_ERROR,
  x => x,
  (x, m) => m
);
export const soloSetMatchedForm = createAction(
  types.SOLO_ANNOTATE_CASTS_SET_MATCHED_FORM
);
export const soloUpdateMatchedForm = createAction(
  types.SOLO_ANNOTATE_CASTS_UPDATE_MATCHED_FORM
);
export const soloUpdateCast = createAction(
  types.SOLO_ANNOTATE_CASTS_UPDATE_CAST
);
export const soloAddFileToAnnotate = createAction(
  types.SOLO_ANNOTATE_ADD_FILE_TO_ANNOTATE
);
export const soloRemoveFileToAnnotate = createAction(
  types.SOLO_ANNOTATE_REMOVE_FILE_TO_ANNOTATE
);
export const soloChartDataFetchRequest = createAction(
  types.SOLO_CHART_DATA_FETCH_REQUEST
);
export const soloChartDataFetchSuccess = createAction(
  types.SOLO_CHART_DATA_FETCH_SUCCESS
);
export const soloChartDataFetchError = createAction(
  types.SOLO_CHART_DATA_FETCH_ERROR
);

/* eslint-enable max-len */

// ASYNC ACTIONS FOR FETCHING FILES NEEDING ANNOTATATION
const soloFilesToAnnotateFetch = () => (dispatch, getState) => {
  const { workarea, organization } = annotatePropsSelector(getState());
  dispatch(soloFilesToAnnotateFetchRequest());
  apiGet(
    `/solo/views/solo_files_to_annotate?work_area=${workarea}&organization=${organization}&fields=filename,solo_file_pk,file_bytes,collection_dt,num_casts,device_sn&limit=-1`
  )
    .then(res => res.json())
    .then(humps.camelizeKeys)
    .then(json => dispatch(soloFilesToAnnotateFetchSuccess(json)))
    .catch(err => dispatch(soloFilesToAnnotateFetchError(err)));
};
export const soloFilesToAnnotateFetchIfNeeded = () => (dispatch, getState) => {
  const state = getState();
  const {
    soloFilesList,
    soloFilesDidInvalidate,
    soloFilesFetching
  } = annotatePropsSelector(state);
  if (
    (soloFilesList.length <= 0 || soloFilesDidInvalidate) &&
    !soloFilesFetching
  ) {
    dispatch(soloFilesToAnnotateFetch());
  }
};

// ASYNC ACTIONS FOR FETCHING CASTS AND POSSIBLY MATCHING FORMS FOR A SPECIFIC FILE
const soloCastsToAnnotateFetch = ({ soloFilePk }) => (dispatch, getState) => {
  const { workarea, organization } = annotatePropsSelector(getState());
  dispatch(soloCastsToAnnotateFetchRequest({ soloFilePk }));
  apiGet(
    `/solo/views/solo_casts_to_annotate?work_area=${workarea}&organization=${organization}&solo_file_pk=${soloFilePk}&limit=-1`
  )
    .then(res => res.json())
    .then(humps.camelizeKeys)
    .then(json =>
      dispatch(
        soloCastsToAnnotateFetchSuccess(
          json.map(c => {
            if (c.possibleForms == null && c.mostLikelyMatchIndex == null) {
              return {
                ...c,
                soloMatchedForm: null
              };
            }
            return {
              ...c,
              soloMatchedForm: c.possibleForms[c.mostLikelyMatchIndex]
            };
          })
        )
      )
    )
    .catch(err => {
      // console.log(err);
      return dispatch(soloCastsToAnnotateFetchError(err));
    });
};
export const soloCastsToAnnotateFetchIfNeeded = ({ soloFilePk }) => (
  dispatch,
  getState
) => {
  const state = getState();
  const { soloSavingFile, soloFetchedFilePks } = annotatePropsSelector(state);
  if (!soloSavingFile && !soloFetchedFilePks.includes(soloFilePk)) {
    dispatch(soloCastsToAnnotateFetch({ soloFilePk }));
  }
};

// ASYNC ACTION FOR FETCHING DATA TO DISPLAY CAST CHART
export const soloChartDataFetch = ({
  soloFilePk,
  startDt,
  endDt
}) => dispatch => {
  const startWindow = moment(startDt)
    .subtract(3, "m")
    .format();
  const endWindow = moment(endDt)
    .add(3, "m")
    .format();
  dispatch(soloChartDataFetchRequest({ soloFilePk }));
  apiGet(
    `/solo/views/file/data?limit=-1&solo_file_pk=${soloFilePk}&measurement_dt>=${startWindow}&measurement_dt<=${endWindow}&sort=measurement_dt&fields=measurement_dt,depth`
  )
    .then(res => res.json())
    .then(humps.camelizeKeys)
    .then(data => data.map(d => ({ ...d, depth: -d.depth })))
    .then(json => dispatch(soloChartDataFetchSuccess(json)))
    .catch(err => dispatch(soloChartDataFetchError(err)));
};

// ASYNC ACTION TO ANNOTATE THE FILE IN THE database
export const soloAnnotateFiles = () => (dispatch, getState) => {
  const {
    soloFilesBeingAnnotated: soloFilePks,
    soloFilesToAnnotate,
    soloCastsInFiles,
    soloMatchedForms,
    workarea
  } = annotatePropsSelector(getState());
  const files = soloFilePks.map(pk => ({
    soloFilePk: soloFilesToAnnotate[pk].soloFilePk,
    filename: soloFilesToAnnotate[pk].filename,
    casts: Object.keys(soloCastsInFiles[pk]).map(cast => ({
      soloCastPk: soloCastsInFiles[pk][cast].soloCastPk,
      soloMatchedForm: soloMatchedForms[soloCastsInFiles[pk][cast].soloCastPk],
      miscast: soloCastsInFiles[pk][cast].miscast,
      comments: soloCastsInFiles[pk][cast].comments,
      bottomDt: soloCastsInFiles[pk][cast].bottomDt
    }))
  }));

  files.forEach(f => {
    const { soloFilePk, casts, filename } = f;
    Promise.resolve(dispatch(soloAnnotateFilesRequest({ soloFilePk })))
      .then(() => handleSoloAnnotation(casts, workarea))
      .then(() => dispatch(soloAnnotateFilesSuccess({ soloFilePk, filename })))
      .then(() => dispatch(soloUploadFilesInvalidate()))
      .then(() => dispatch(soloConfirmFilesInvalidate()))
      .then(() => dispatch(soloOpenAnnotationSnackbar()))
      .catch(err => dispatch(soloAnnotateFilesError(err, { soloFilePk })));
  });
};

export const soloRemoveFile = soloFilePk => (dispatch, getState) => {
  const { soloFilesToAnnotate, workarea } = annotatePropsSelector(getState());
  const { comments } = soloFilesToAnnotate[soloFilePk];
  Promise.resolve(dispatch(soloRemoveFileRequest({ soloFilePk })))
    .then(() => handleSoloRemoveFile({ soloFilePk, comments }, workarea))
    .then(() => dispatch(soloRemoveFileSuccess({ soloFilePk })))
    .then(() => dispatch(soloFilesToAnnotateInvalidate()))
    .catch(err => dispatch(soloRemoveFileError(err, { soloFilePk })));
};
